import { useEffect } from "react";

export default function Seo({ title, description, path = "" }) {
  useEffect(() => {
    document.title = title ? `${title} · Aetheria Numerology` : "Aetheria Numerology";
    const setMeta = (name, content, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const desc = description || "Personalized numerology readings, thoughtfully crafted around your numbers and delivered as a beautiful PDF. Pythagorean & Chaldean traditions.";
    setMeta("description", desc);
    setMeta("og:title", title || "Aetheria Numerology", true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "website", true);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${window.location.origin}${path}`);
  }, [title, description, path]);
  return null;
}
